export const platformConfig = {
  apiUrl: "http://localhost:3000/api/v1",
  production: false
};